module.exports = __webpack_public_path__ + "img/2.c13cf46a.png";